<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [css]="question.css"
  [key]="question.key"
  [value]="value"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>

<ion-list [formGroup]="formGroup">
  <ion-item>
    <div class="selectedChips" *ngIf="!!selectedChips.length">
      <div *ngFor="let chip of selectedChips">
        <ion-chip [ngStyle]="{ background: color }" (click)="deleteChip(chip)">
          <ion-label>{{ chip.key }}</ion-label>
          <ion-icon
            [ngStyle]="{ background: color }"
            name="close-circle"
          ></ion-icon>
        </ion-chip>
      </div>
    </div>
    <ion-select
      multiple="true"
      interface="alert"
      [class.hideDefaultIonicText]="getChipsSelected().length"
      [interfaceOptions]="customPopoverOptions"
      [placeholder]="question.placeholder | translate"
      [formControlName]="question.key"
      [attr.disabled]="question.disabled || question.readonly"
      [cancelText]="question.cancelText | translate"
      [okText]="question.okText | translate"
      (ionChange)="selectChip($event)"
    >
      <ion-select-option
        *ngFor="let option of question.options"
        [value]="option.value"
      >
        {{ option.key }}
      </ion-select-option>
    </ion-select>
  </ion-item>
</ion-list>
